<template>
    <a-modal title="移除原因"
             :width="1000"
             :visible="visible"
             :destroyOnClose="true"
             :maskClosable="false"
             :confirmLoading="modalLoading"
             @ok="onSupplierDelSave"
             @cancel="$emit('cancel')">
        <div>
            <a-card>
                <a-form :form="supplierDelForm" class="pick-100">
                    <a-row type="flex" justify="space-between" class="form-input about">
                        <a-col :span="24">
                            <a-form-item label="移除原因">
                                <a-textarea
                                        placeholder="移除原因"
                                        :auto-size="{ minRows: 3, maxRows: 6 }"
                                        v-decorator="['ycyy',{rules: [{ required: true, message: '请填写移除原因' }]}]"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
  import { PageView } from '@/layouts'
  import qs from 'qs'
  export default {
    name: 'PreDelSupplier',
    props: ['visible','systemType'],
    components: {
      PageView
    },
    data () {
      return {
        supplierDelForm: this.$form.createForm(this),
        modalLoading:false,
        attend:{}
      }
    },
    mounted () {
    },
    created () {
    },
    methods: {
      onSupplierDelSave () {
        let that = this
        that.supplierDelForm.validateFields((err, values) => {
          if (err) {
            return
          }
          that.modalLoading = true
           const data = that.supplierDelForm.getFieldsValue()
          data.type = that.systemType
          data.id = that.attend.id
          data.delTarget = that.attend.delTarget
          data.BondId = that.attend.BondId
          data.isCanDel =that.attend.isCanDel
          data.projectId =that.attend.projectId
          data.supplierCode =that.attend.supplierCode
          console.log(data)
          let url = '/api/1/signSupplier/saveAndDelSupplier.json'
          if ("1" ===  that.attend.xmjn)
          {
            url = '/api/1/signSupplier/saveAndDelSupplierByProject.json'
          }
          that.$http.post(url, qs.stringify(data)).then(function (response) {
          if (response.code !== 200) {
            return
          }
          that.$message.success("删除成功")
            that.modalLoading = false
            that.$emit('success',that.attend.xmjn)
            that.attend={}
        })
        })
      },
      onLoad (data,delTarget,BondId,isCanDel,xmjn){
        let that=this
        that.attend={}
        that.attend = data
        that.attend.xmjn  = xmjn
        that.attend.BondId  = BondId
        that.attend.isCanDel  = isCanDel
        that.attend.delTarget = delTarget
      }
    }
  }
</script>

<style scoped>
</style>
